


















































import { Component, Vue, Prop } from "vue-property-decorator";
import PicView from "@/components/pic-preview.vue";
@Component({
  components: {
    PicView,
  },
})
export default class SzksDanxuan extends Vue {
  @Prop()
  private question;
  @Prop()
  private index;
  @Prop()
  private filters;
  @Prop()
  private answer;
  private ifShowPic: boolean = false;
  private index2Alpha: any[] = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
  ];
  /**
   * @description 判断是否选中
   */
  private ifSelect(o) {
    if (!this.answer || !this.answer["reply"]) {
      return false;
    }
    if (o === this.answer["reply"][0]) {
      return true;
    } else {
      return false;
    }
  }
  /**
   * @description 判断是否答对
   */
  private ifCorrect(o) {
    if (o === this.answer["正确答案"][0]) {
      return true;
    } else {
      return false;
    }
  }
}
